import { type Components } from "react-markdown";

// Component overrides tuned for compact source-quote surfaces (popover preview
// and PDF-modal sidebar). Headings collapse to `<p>`-with-bold so they don't
// dominate the small surface, list spacing tightens, and tables shrink.
// Module-level so identity stays stable across renders and the renderer
// doesn't reconcile new function refs on each parent re-render.
export const sourceQuoteMarkdownComponents: Components = {
    p: ({ ...props }) => (
        <p className="my-1.5 first:mt-0 last:mb-0" {...props} />
    ),
    h1: ({ ...props }) => (
        <p className="my-1.5 font-semibold first:mt-0 last:mb-0" {...props} />
    ),
    h2: ({ ...props }) => (
        <p className="my-1.5 font-semibold first:mt-0 last:mb-0" {...props} />
    ),
    h3: ({ ...props }) => (
        <p className="my-1.5 font-semibold first:mt-0 last:mb-0" {...props} />
    ),
    h4: ({ ...props }) => (
        <p className="my-1.5 font-semibold first:mt-0 last:mb-0" {...props} />
    ),
    h5: ({ ...props }) => (
        <p className="my-1.5 font-semibold first:mt-0 last:mb-0" {...props} />
    ),
    h6: ({ ...props }) => (
        <p className="my-1.5 font-semibold first:mt-0 last:mb-0" {...props} />
    ),
    ul: ({ ...props }) => (
        <ul className="my-1 ml-4 list-disc [&>li]:mt-0.5" {...props} />
    ),
    ol: ({ ...props }) => (
        <ol className="my-1 ml-4 list-decimal [&>li]:mt-0.5" {...props} />
    ),
    li: ({ ...props }) => <li className="leading-relaxed" {...props} />,
    strong: ({ ...props }) => <strong className="font-semibold" {...props} />,
    em: ({ ...props }) => <em className="italic" {...props} />,
    code: ({ ...props }) => (
        <code
            className="bg-muted/60 rounded px-1 py-0.5 font-mono text-[11px]"
            {...props}
        />
    ),
    blockquote: ({ ...props }) => (
        <blockquote
            className="border-muted-foreground/30 text-muted-foreground my-1 border-l-2 pl-2 italic"
            {...props}
        />
    ),
    a: ({ href, ...props }) => (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary underline underline-offset-2"
            {...props}
        />
    ),
    table: ({ ...props }) => (
        <div className="my-1 overflow-x-auto">
            <table className="text-[12px]" {...props} />
        </div>
    ),
    th: ({ ...props }) => (
        <th
            className="border-border border-b px-1.5 py-0.5 text-left font-medium"
            {...props}
        />
    ),
    td: ({ ...props }) => (
        <td className="border-border/40 border-b px-1.5 py-0.5" {...props} />
    ),
    hr: () => <hr className="border-border/50 my-1.5" />,
};
